import { v4 as uuidv4 } from 'uuid';
import {
  APPLICATION_JSON, CLIENT_ID, INCLUDE, POST,
} from '../constants/constants';
import { getBookingsServiceApiUrl } from '../selectors/selectors';

export default {
  fetch: ({
    pnrNumber, bookingType, bookingDate, locale,
    correlationId,
  }, action, state) => {
    const request = {
      pnr_number: pnrNumber,
      booking_type: bookingType,
      booking_date: bookingDate,
    };
    return {
      url: `${getBookingsServiceApiUrl(state)}/booking/detail/fetch?type=receipt`,
      opts: {
        method: POST,
        credentials: INCLUDE,
        headers: {
          Accept: APPLICATION_JSON,
          'Content-Type': APPLICATION_JSON,
          'x-correlation-id': correlationId || uuidv4(),
          'x-client-id': CLIENT_ID,
          'x-locale': locale,
        },
        body: JSON.stringify(request),
      },
    };
  },
  transformData: (data) => {
    const rateDetails = data?.flightCostInformationDetails
                        || data?.exchangedCredit
                        || data?.hotelRateDetails
                        || data?.carRateDetails
                        || data?.limoRateDetails
                        || data?.tourRateDetails
                        || data?.vacationRentalRateDetails;
    return { ...data, rateDetails };
  },
};
